export default "__VITE_ASSET__BKYUv0Kh__"